module.exports = __webpack_public_path__ + "static/media/logo-blue.495870f3.svg";